import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  submitQuote: (data) => axios.post(`${API}/quotes`, data).then((r) => r.data),
  getAvailability: (days = 21) => axios.get(`${API}/availability?days=${days}`).then((r) => r.data),
  createBooking: (data) => axios.post(`${API}/bookings`, data).then((r) => r.data),
  getBooking: (code) => axios.get(`${API}/bookings/${code}`).then((r) => r.data),
  getReviews: () => axios.get(`${API}/reviews`).then((r) => r.data),
  adminLogin: (passcode) => axios.post(`${API}/auth/admin-login`, { passcode }, { withCredentials: true }).then((r) => r.data),
  adminCheck: () => axios.get(`${API}/auth/admin-check`, { withCredentials: true }).then((r) => r.data),
  adminLogout: () => axios.post(`${API}/auth/admin-logout`, {}, { withCredentials: true }).then((r) => r.data),
  adminQuotes: () => axios.get(`${API}/admin/quotes`, { withCredentials: true }).then((r) => r.data),
  adminSetQuoteStatus: (id, status) => axios.patch(`${API}/admin/quotes/${id}`, { status }, { withCredentials: true }).then((r) => r.data),
};
